import { useState, useEffect } from "react";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { STAGES, PLAN_META } from "@/data/backofficeData";

const EMPTY = { name: "", type: "clinica", contact: "", phone: "", email: "", city: "", specialty: "", plan: "basic", value: 399, stage: "prospeccao" };

export const LeadForm = ({ open, onOpenChange, editing, onSave }) => {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    setForm(editing ? { ...EMPTY, ...editing } : EMPTY);
  }, [editing, open]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = () => {
    if (!form.name.trim()) return toast.error("Informe o nome do médico ou clínica.");
    onSave({ ...form, value: Number(form.value) || 0 });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="lead-form-modal" className="max-w-md">
        <DialogHeader>
          <DialogTitle>{editing ? "Editar Lead" : "Novo Lead (Médico / Clínica)"}</DialogTitle>
          <DialogDescription>Cadastre um médico ou clínica prospectado(a) no funil comercial.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs font-semibold text-slate-600">Tipo</Label>
              <Select value={form.type} onValueChange={(v) => set("type", v)}>
                <SelectTrigger data-testid="lead-type-select" className="mt-1.5"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="clinica">Clínica</SelectItem>
                  <SelectItem value="medico">Médico(a)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs font-semibold text-slate-600">Estágio</Label>
              <Select value={form.stage} onValueChange={(v) => set("stage", v)}>
                <SelectTrigger data-testid="lead-stage-select" className="mt-1.5"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {STAGES.map((s) => <SelectItem key={s.id} value={s.id}>{s.label}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div><Label className="text-xs font-semibold text-slate-600">Nome do médico / clínica</Label><Input data-testid="lead-name-input" value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-1.5" placeholder="Ex.: Clínica São Lucas" /></div>
          <div><Label className="text-xs font-semibold text-slate-600">Responsável / Contato</Label><Input data-testid="lead-contact-input" value={form.contact} onChange={(e) => set("contact", e.target.value)} className="mt-1.5" placeholder="Ex.: Dr. João Silva" /></div>
          <div><Label className="text-xs font-semibold text-slate-600">Especialidade</Label><Input data-testid="lead-specialty-input" value={form.specialty} onChange={(e) => set("specialty", e.target.value)} className="mt-1.5" placeholder="Ex.: Cardiologia, Pediatria, Dermatologia..." /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><Label className="text-xs font-semibold text-slate-600">Telefone</Label><Input data-testid="lead-phone-input" value={form.phone} onChange={(e) => set("phone", e.target.value)} className="mt-1.5" placeholder="+55 ..." /></div>
            <div><Label className="text-xs font-semibold text-slate-600">Cidade / UF</Label><Input data-testid="lead-city-input" value={form.city} onChange={(e) => set("city", e.target.value)} className="mt-1.5" placeholder="São Paulo / SP" /></div>
          </div>
          <div><Label className="text-xs font-semibold text-slate-600">E-mail</Label><Input data-testid="lead-email-input" type="email" value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-1.5" placeholder="contato@..." /></div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-xs font-semibold text-slate-600">Plano de interesse</Label>
              <Select value={form.plan} onValueChange={(v) => set("plan", v)}>
                <SelectTrigger data-testid="lead-plan-select" className="mt-1.5"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {Object.entries(PLAN_META).map(([k, m]) => <SelectItem key={k} value={k}>{m.label}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div><Label className="text-xs font-semibold text-slate-600">Valor mensal (R$)</Label><Input data-testid="lead-value-input" type="number" value={form.value} onChange={(e) => set("value", e.target.value)} className="mt-1.5" /></div>
          </div>
        </div>
        <DialogFooter>
          <button onClick={() => onOpenChange(false)} className="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50">Cancelar</button>
          <button data-testid="lead-save-btn" onClick={save} className="rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-bold text-white hover:bg-slate-800">{editing ? "Salvar" : "Adicionar Lead"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
